import { CREATE_FOR_HINT, CREATE_FOR_QUESTION } from '@/data/applicationInstall'
import type { CreatedFor } from '@/types/application'
import styles from './Infrastructure.module.css'
import { OptionCard } from './OptionCard'

interface CreatedForQuestionProps {
  value: CreatedFor | null
  onChange: (value: CreatedFor) => void
}

/**
 * "Is the application being created for Production or Sandbox?", asked in a production environment, which holds both. A labelled,
 * required group of two real radio inputs, unanswered until the user chooses.
 */
export function CreatedForQuestion({ value, onChange }: CreatedForQuestionProps) {
  return (
    <fieldset className={styles.cardGroup} role="radiogroup" aria-required="true" data-testid="created-for">
      <legend className={styles.legend}>{CREATE_FOR_QUESTION}</legend>
      <OptionCard name="created-for" value="Production" checked={value === 'Production'} onChange={() => onChange('Production')} title="Production" description="The customer's live environment: the Production key is the Product ID." />
      <OptionCard name="created-for" value="Sandbox" checked={value === 'Sandbox'} onChange={() => onChange('Sandbox')} title="Sandbox" description="The customer's test environment: the Sandbox key is the Product ID." />
      <p className={styles.note}>{CREATE_FOR_HINT}</p>
    </fieldset>
  )
}
